// The helpline number comes from runtime/build config, never the code.
// Until one is configured, a placeholder keeps the helpline visible. Its
// "000" area code is unassigned, so it can never ring a real person.
const PLACEHOLDER_PHONE_NUMBER = "+92 000 0000000";

export const emergencyPhoneNumber = (
  window.__ENV__?.HELPLINE_PHONE_NUMBER ||
  process.env.REACT_APP_HELPLINE_PHONE_NUMBER ||
  PLACEHOLDER_PHONE_NUMBER
).trim();
export const emergencyDialNumber = emergencyPhoneNumber.replace(/[^\d+]/g, "");
export const canCallEmergency = /^\+?\d{3,15}$/.test(emergencyDialNumber);
